module.exports = __webpack_public_path__ + "img/breakfast_available.6cba8953.png";